const EVENT_QUERY_KEYS = ['league', 'away', 'home', 'date', 'start', 'sourceEventId']

export function resolveDashboardRoute(sections, search = '') {
  const params = new URLSearchParams(search)
  const requestedSection = params.get('section')
  const section = sections[requestedSection] || sections.home || Object.values(sections)[0]
  const requestedTab = params.get('tab')
  const tab = section.tabs.find((entry) => entry.id === requestedTab) || section.tabs[0]
  return { sectionId: section.id, tabId: tab.id }
}

export function buildDashboardUrl(currentHref, sectionId, tabId) {
  const url = new URL(currentHref)
  url.searchParams.set('section', sectionId)
  url.searchParams.set('tab', tabId)
  if (sectionId !== 'event') {
    EVENT_QUERY_KEYS.forEach((key) => url.searchParams.delete(key))
  }
  return `${url.pathname}${url.search}${url.hash}`
}

export function readEventTarget(search = '') {
  const params = new URLSearchParams(search)
  const target = {
    league: params.get('league') || '',
    awayTeam: params.get('away') || '',
    homeTeam: params.get('home') || '',
    date: params.get('date') || '',
    startTime: params.get('start') || '',
    sourceEventId: params.get('sourceEventId') || '',
  }
  return target.awayTeam && target.homeTeam ? target : null
}

export function buildEventDashboardUrl(currentHref, target) {
  const url = new URL(currentHref)
  url.searchParams.set('section', 'event')
  url.searchParams.set('tab', 'overview')
  const values = {
    league: target?.league,
    away: target?.awayTeam,
    home: target?.homeTeam,
    date: target?.date,
    start: target?.startTime,
    sourceEventId: target?.sourceEventId,
  }
  Object.entries(values).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value)
    else url.searchParams.delete(key)
  })
  return `${url.pathname}${url.search}${url.hash}`
}

export function writeDashboardRoute(sectionId, tabId, { replace = false } = {}) {
  if (typeof window === 'undefined') return
  const nextUrl = buildDashboardUrl(window.location.href, sectionId, tabId)
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`
  if (nextUrl === currentUrl) return
  window.history[replace ? 'replaceState' : 'pushState']({ sectionId, tabId }, '', nextUrl)
}

export function writeEventDashboardRoute(target, { replace = false } = {}) {
  if (typeof window === 'undefined') return
  const nextUrl = buildEventDashboardUrl(window.location.href, target)
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`
  if (nextUrl === currentUrl) return
  window.history[replace ? 'replaceState' : 'pushState']({ sectionId: 'event', tabId: 'overview', eventTarget: target }, '', nextUrl)
}
